import { routePaths } from "@/App";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { useTourStop } from "@/libs/tours-detail/hooks/useTourStop";
import { ChevronLeft, UserIcon } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, Navigate, useNavigate, useParams } from "react-router";

export default function GatherPickupDetailPage() {
  const { t } = useTranslation();
  const [note, setNote] = useState("");
  const navigate = useNavigate();

  const { id, stopId, taskId } = useParams<{
    id: string;
    stopId: string;
    taskId: string;
  }>();

  const { currentStop, handleGatherPickupFailed, handleGatherStopLoad } =
    useTourStop(stopId!);

  const currentTask = currentStop?.items.find(
    (item) => item.id === (taskId as string),
  );

  if (!currentStop || !currentTask) {
    return <Navigate to={routePaths.createTourPath(id!)} />;
  }

  return (
    <div className="h-full flex flex-col">
      <div className="bg-white px-4 py-6 border-b-2 border-neutral pt-safe">
        <Link
          to={routePaths.createTourStopPath(
            id as string,
            stopId as string,
            currentTask.type,
          )}
          className="mb-8 flex items-center font-medium gap-1.5 w-fit p-2 pr-4 rounded"
        >
          <ChevronLeft className="w-5 h-5" strokeWidth={2.5} />
          {t("common.back")}
        </Link>

        <div className="space-y-2">
          <h3 className="text-xl font-semibold">
            {t("gatherPickup.header.title")}
          </h3>

          <div className="space-y-4 mt-6">
            <div className="flex items-center text-sm font-medium text-[#6A80A8]">
              <UserIcon className="w-5 h-5 mr-2" strokeWidth={2.5} />
              {currentTask?.name}
            </div>
          </div>
        </div>
      </div>

      <div className="overflow-y-scroll pb-12 bg-list-background h-full flex-1">
        <div className="p-4 h-full">
          <Textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder={t("gatherDropoff.notePlaceholder")}
            rows={8}
          />
        </div>
      </div>

      <div className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t-2 border-neutral pb-safe">
        <div className="space-y-4">
          <Button
            className="w-full bg-green-400 hover:bg-green-500 text-black font-semibold"
            onClick={async () => {
              handleGatherStopLoad(currentTask.id, currentTask.parentId);

              navigate(
                routePaths.createTourStopPath(
                  currentTask.parentId as string,
                  currentTask.id as string,
                  currentTask.type as string,
                ),
              );
            }}
          >
            {t("gatherPickup.collect.single")}
          </Button>
          <Button
            className="w-full bg-red-400 hover:bg-red-500 text-black font-semibold"
            onClick={() =>
              handleGatherPickupFailed(
                currentTask?.parentId as string,
                currentTask?.id as string,
                {
                  driverNote: note,
                },
              )
            }
          >
            {t("gatherPickup.collect.failed")}
          </Button>
        </div>
      </div>
    </div>
  );
}
